import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Platform } from "@ionic/angular";
import { ConexionServiceProvider, ConnectionStatus } from "../conexion-service/conexion-service";
import { SQLite, SQLiteObject } from '@awesome-cordova-plugins/sqlite/ngx';
import { ApiService } from "src/app/api.service";

@Injectable({
	providedIn: "root",
})
export class OfflineService {
	disconnectSubscription: any;
	connectSubscription: any;
	networkAlert: HTMLIonAlertElement;
	requestSubscriber: any;
	mutex = true;

  private isSendingRequests = false;

	private database: SQLiteObject;

	constructor(
		private http: HttpClient,
		private platform: Platform,
		private networkService: ConexionServiceProvider,
		private sqlite: SQLite,
    private api: ApiService,
	) {
		if (this.platform.is("cordova")) {
			this.createPendingRequestTable();
		}
	}

	async sendPendingOfflineRequests() {
		this.networkService.onNetworkChange().subscribe((status: ConnectionStatus) => {
			if (status == ConnectionStatus.Online) {
				this.sendPendingsHttpRequests();
			}
		});
	}

	async createSQLdb() {
		try {
			const userData = JSON.parse(localStorage.getItem("user_data"));
			const db = await this.sqlite.create({
				name: `${userData.dni}.db`,
				location: "default",
			});
			if (db) {
				this.database = db;
			}
		} catch (error) {
			console.error("**********Error opening database offline service*********",error);
		}
	}

  async createPendingRequestTable() {
		// if(!this.database) {
		// await this.createSQLdb();
		try {
			await this.createSQLdb();
      // is_sst is a controller to know if the request is for signatures(training or custom certificate) is used to order requests in sendRequests method
			const res = await this.database.executeSql(
				`CREATE TABLE IF NOT EXISTS http_requests  (
          id  text primary key,
          url text,
          method text,
          data text,
          is_sst integer
        )`,
				[]
			);
			console.log("tabla request created: ", res);
		} catch (error) {
			console.log("ERROR createPendingRequestTable ", error);
		}
	}

	async sendPendingsHttpRequests() {
    if (this.isSendingRequests) {
        return;
    }
    this.isSendingRequests = true;
    setTimeout(async () => {
      console.log("send pending request");
      try {
          await this.createSQLdb();
          const data = await this.database.executeSql("SELECT * FROM http_requests ORDER BY is_sst ASC", []);
          let rawRequest = [];
          if (data.rows.length) {
              for (let i = 0; i < data.rows.length; i++) {
                  rawRequest.push(data.rows.item(i));
              }
          }
          // console.log("rawRequest::", rawRequest);

          for (const request of rawRequest) {
            try {
              await this.sendRequests(request);
            } catch (error) {
              console.error(`Error al procesar la solicitud ${request.id}, continuando con la siguiente.`, error);
            }
          }

      } catch (error) {
          console.error(error);
      } finally {
          this.isSendingRequests = false;
      }
    }, 4000);
    }

    sendRequests(request): Promise<any> {
        if (request.method === "GET") {
            return this.http
                .request(request.method, request.url)
                .toPromise()
                .then((response) => {
                    return this.database
                        .executeSql("DELETE FROM http_requests WHERE id = ?", [request.id])
                        .then(() =>
                            console.log("enviada y eliminada",request.id)
                        )
                        .catch((error) =>
                            console.error("Error al eliminar las solicitudes pendientes:",request.id,error)
                        );
                })
                .catch((error) => {
                    console.log(
                        "error get http request: ",
                        error
                    );
                    throw error;
                });
        }
        else {
            return this.http
                .request(request.method, request.url, { body:  request.data })
                // .request(request.method, request.url, { body:  JSON.parse(request.data) })
                .toPromise()
                .then((response) => {
                    return this.database
                        .executeSql("DELETE FROM http_requests WHERE id = ?", [request.id])
                        .then(() =>
                            console.log("enviada y eliminada correctamente:",request.id)
                        )
                        .catch((error) =>
                            console.error("Error al eliminar las solicitudes pendientes:",request.id,error)
                        );
                })
                .catch((error) => {
                    console.log(
                        "error http request: ",
                        error
                    );
                    throw error;
                });
        }
    }

  async saveOfflineTrainingSignatureRequest(canvaImgData, courseID) {
    await this.createPendingRequestTable();
    let body = {
      signature: canvaImgData,
      course_id: courseID,
      is_offline: true,
      created_at: new Date(),
    };
    const apiConnectors = this.api.getApiUrls;
    let query = 'INSERT OR REPLACE INTO http_requests VALUES (?, ?, ?, ?, ?)';
    try {
      await this.database
      .executeSql(query, [
        `${courseID}_sst`,
        apiConnectors.serviceBaseRest + 'cursos/registro-capacitacion',
        'POST',
        JSON.stringify(body),
        1,
      ]);
      console.log( 'registro-capacitacion Datos insertados en SQLite',courseID);
    } catch (error) {
        console.log(`Error al insertar datos en SQLite registro-capacitacion: ${courseID}`,error)
    };
  }

  async saveOfflineCertificateSignatureRequest(canvaImgData, courseID) {
    await this.createPendingRequestTable();
    let body = {
      signature: canvaImgData,
      course_id: courseID
      // is_offline: true,
      // created_at: new Date(),
    };
    const apiConnectors = this.api.getApiUrls;
    let query = 'INSERT OR REPLACE INTO http_requests VALUES (?, ?, ?, ?, ?)';
    try {
      await this.database
      .executeSql(query, [
        `${courseID}_cert`,
        apiConnectors.serviceBaseRest + 'cursos/registro-personalizado',
        'POST',
        JSON.stringify(body),
        1,
      ]);
      console.log( 'registro-personalizado Datos insertados en SQLite',courseID);
    } catch (error) {
        console.log(`Error al insertar datos en SQLite registro-personalizado: ${courseID}`,error)
    };
  }

}
